import { Box, Typography, useTheme } from '@mui/material';
import React from 'react';

import { SEND_TYPES } from '../../../constants/reports';

const ReportSendType = ({ sendType }: { sendType: string }) => {
  const {
    palette: { common },
  } = useTheme();
  const { title, backgroundColor } = SEND_TYPES.find((el) => el.value === sendType) || {
    backgroundColor: common.white,
  };

  return (
    <Box
      sx={{
        backgroundColor,
        minWidth: 88,
        height: 24,
        borderRadius: 50,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: `1px solid ${common.white}`,
        py: '5px',
        px: '17px',
        width: 'fit-content',
      }}
    >
      <Typography sx={{ textAlign: 'center', whiteSpace: 'nowrap', fontSize: 13 }} color="text.primary">
        {title}
      </Typography>
    </Box>
  );
};

export default ReportSendType;
